import React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../images/logo.png';
import { Icon } from '../../icons/AppIcons';
import '../../css/sidebar.css';

function NavItem({ to, icon, label, exact, activeOverride }) {
  const location = useLocation();
  const active = activeOverride !== undefined
    ? activeOverride
    : exact
      ? location.pathname === to
      : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <ListItemButton
      component={Link}
      to={to}
      className={`side-nav-item${active ? ' active' : ''}`}
    >
      <ListItemIcon>
        <span className="side-nav-icon">
          <Icon name={icon} size={32} />
        </span>
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItemButton>
  );
}

export default function SideBar() {
  const location = useLocation();
  const kofferActive = location.pathname === '/devices'
    || (location.pathname.startsWith('/devices/') && !location.pathname.startsWith('/devices/status'));

  return (
    <>
      <List disablePadding>
        <NavItem to="/" icon="dashboard" label="Dashboard" exact />
        <ListSubheader disableSticky>Überwachung</ListSubheader>
        <NavItem to="/devices" icon="koffer" label="Koffer" activeOverride={kofferActive} />
        <NavItem to="/devices/status" icon="status" label="Status" />
        <NavItem to="/events" icon="events" label="Ereignisse" />
        <NavItem to="/public" icon="alarm" label="Monitor" />
        <ListSubheader disableSticky>Einstellungen</ListSubheader>
        <NavItem to="/user" icon="user" label="Benutzer" />
        <NavItem to="/employees" icon="employees" label="Mitarbeiter" />
        <NavItem to="/company" icon="company" label="Firma" />
      </List>

      <div className="side-nav-footer">
        <img className="bottom-bar-icommunity" src={Logo} alt="FireCore" />
      </div>
    </>
  );
}
